import { trace } from 'owa-trace';
import parseNovaCommand from './utils/parseNovaCommand';
import type { NovaCentralizedCommanding } from '@nova/types';
import type { EntityCommand as OwaEntityCommand } from 'owa-graph-schema';

export const novaCommanding: NovaCentralizedCommanding = {
    trigger(command: any): Promise<void> {
        try {
            const action = parseNovaCommand(command as OwaEntityCommand);
            action(command);
            return Promise.resolve();
        } catch (e) {
            trace.info('Failed to parse nova command, ', e.toString());
            return Promise.reject();
        }
    },
};
